import fall from "../../images/fall.jpg";
import winter from "../../images/winter.jpg";
import spring from "../../images/spring.jpg";
import summer from "../../images/summer.jpg";

export const NAV_COLORS = {
  home: "red",
  about: "purple",
  projects: "blue",
  resume: "green",
  contact: "amber"
};

export const WALLPAPERS = [summer, winter];
